import { useState } from 'react';
import axiosInstance from '../../../Configuration/axiosInstance';

const Register = () => {
  const [payload, setPayload] = useState({
    email: '',
    password: '',
    role: 'user',
  });

  // Handler for input fields
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPayload({ ...payload, [name]: value });
  };

  // Handler for the select element
  const handleRoleChange = (e) => {
    const selectedRole = e.target.value;
    console.log(selectedRole);
    setPayload({ ...payload, role: selectedRole });
  };

  const onSubmit = (e) => {
    e.preventDefault();

    // You can now use the 'payload' state to send the data in your axios post request
    axiosInstance
      .post('/user/signup', payload)
      .then((response) => {
        console.log(response.data);
      })
      .catch((error) => {
        // Handle errors here
      });
  };

  return (
    <>
      <h1>Create New User</h1>
      <form
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: '40vw',
          backgroundColor: 'white',
          marginTop: '15px',
          padding: '10px',
        }}
      >
        <label>Email:</label>
        <input
          type='text'
          name='email'
          onChange={handleInputChange}
          value={payload.email}
        />

        <label>Password:</label>
        <input
          type='password'
          name='password'
          onChange={handleInputChange}
          value={payload.password}
        />

        <label>Role</label>
        <select onChange={handleRoleChange} value={payload.role}>
          <option value='user'>User</option>
          <option value='delivery'>Delivery</option>
          <option value='admin'>Admin</option>
        </select>

        <input type='submit' value='Register' onClick={(e) => onSubmit(e)} />
      </form>
    </>
  );
};

export default Register;
